<template>
  <div v-if="isVisible" class="custom-modal-overlay">
    <div class="custom-modal-container">
      <div class="custom-modal-header">
        <button @click="closeCreateModal" class="close-button">
          <img src="@/assets/img/close.svg" alt="" />
        </button>
        <img src="@/assets/img/home.png" alt="" />
        <h5>Account Details</h5>
      </div>

      <div class="custom-modal-body">
        <div class="input-container">
          <label for="bank-name">Bank Name</label>
          <p>{{ virtualAccount.bankName }}</p>
        </div>

        <div class="input-container">
          <label for="account-number">Account Number</label>
          <p>{{ virtualAccount.accountNumber }}</p>
        </div>

        <div class="input-container">
          <label for="account-name">Account Name</label>
          <p>{{ virtualAccount.payzeepAccountName }}</p>
        </div>

        <div class="input-container">
          <label for="date-created">Created</label>
          <p>
            {{ formatDate(virtualAccount.createdAt) }}
          </p>
        </div>
      </div>

      <div class="custom-modal-footer">
        <p>
          An account number will be generated for you to directly transfer money
          to your business. You can deactivate this account anytime in the
          future.
        </p>
        <button class="update-btn" @click="closeCreateModal">Done</button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    virtualAccount: {
      type: Object,
      required: true,
    },
    isVisible: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    closeCreateModal() {
      this.$emit("close");
      window.location.reload();
    },

    closeModal() {
      this.showModal = false;
      console.log("modal closed");
    },

    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>

<style scoped>
.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.custom-modal-container {
  background-color: white;
  width: 100%;
  border-radius: 8px;
  max-width: 720px;
  overflow: hidden;
  padding: 30px 60px 60px 60px;
}

.custom-modal-header {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

.close-button {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: end;
  width: 100%;
}

.custom-modal-header h5 {
  color: #000;
  font-size: 32px;
  font-weight: 600;
}

.custom-modal-body {
  width: 100%;
  max-width: 450px;
  margin: auto;
}

.custom-modal-footer {
  text-align: center;
  margin: auto;
  margin-top: 40px;
}

.custom-modal-footer p {
  color: #000;
}

.update-btn {
  border: none;
  outline: none;
  color: white;
  background: #65b3c7;
  font-size: 16px;
  font-weight: 700;
  width: 100%;
  padding: 16px;
  border-radius: 50px;
  max-width: 380px;
}

.input-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-bottom: 14px;
  border: 1px solid #ced3dd;
  background-color: #f7f7f7;
  border-radius: 4px;
  padding: 6px;
}

.input-container label {
  font-weight: 600;
  color: #9497b8;
  font-size: 12px;
}

.input-container p {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #02030d;
  text-transform: capitalize;
}

.input-select {
  background-color: #fff;
  cursor: not-allowed;
  color: #9a9a9a;
  opacity: 1;
  padding: 7px 18px;
  height: 40px;
  border-radius: 4px;
  outline: none;
  border: 1px solid #ddd;
}
</style>
